import { getCommonConfig, updateCommonConfig } from "@/services/commonconfig";
import React, { useEffect, useState } from "react";

const Toggle = ({ value, onChange }: any) => (
  <div className="flex border border-gray-300 rounded overflow-hidden">
    <button
      className={`px-3 py-1 text-xs ${value ? "bg-orange-500 text-white" : "bg-gray-100 text-gray-600"}`}
      onClick={() => onChange(true)}
    >
      Show
    </button>
    <button
      className={`px-3 py-1 text-xs ${!value ? "bg-orange-500 text-white" : "bg-gray-100 text-gray-600"}`}
      onClick={() => onChange(false)}
    >
      Hide
    </button>
  </div>
);

const AccessibilityConfig: React.FC = () => {
  const [data, setData] = useState<any>({});
  const [initial, setInitial] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    const res = await getCommonConfig();
    setData(res);
    setInitial(JSON.stringify(res));
  };

  const updateField = (key: string, val: boolean) => {
    setData((prev: any) => ({ ...prev, [key]: val }));
  };

  const hasChanges = JSON.stringify(data) !== initial;

  const handleSave = async () => {
    setSaving(true);
    await updateCommonConfig(data);
    setInitial(JSON.stringify(data));
    setSaving(false);
  };

  const handleCancel = () => {
    setData(JSON.parse(initial));
  };

  const fields = [
    ["HighContrast", "High Contrast"],
    ["UnderlineLinks", "Underline Links"],
    ["TextSpacing", "Text Spacing"],
    ["ReduceMotion", "Reduce Motion"],
    ["KeyboardNavigation", "Keyboard Navigation"],
    ["FocusIndicators", "Focus Indicators"],
    ["CursorSize", "Cursor Size"],
    ["TTS", "Text to Speech"],
    ["SpeechRate", "Speech Rate"],
    ["TTSOnFocus", "Text to Speech On Focus"],
    ["TTSOnHover", "Text to Speech On Hover"],
    ["ScreenReaderOptimization", "Screen Reader Optimization"],
    ["DyslexiaFriendlyFont", "Dyslexia Friendly Font"],
  ];

  return (
    <div className="border border-gray-200 rounded-md bg-[#fbfaf7] p-3 space-y-2">

      {fields.map(([key, label]) => (
        <div key={key} className="flex items-center gap-4 text-xs">
          <span className="w-48">{label}</span>
          <Toggle value={data[key]} onChange={(v: any) => updateField(key, v)} />
        </div>
      ))}

      <div className="flex justify-end gap-2 items-center pt-2">
        {hasChanges && (
          <div className="text-orange-600 border border-orange-300 bg-orange-50 px-2 py-0.5 rounded text-xs">
            Unsaved
          </div>
        )}

        <button
          className="bg-[#e7e5e0] px-3 py-1 text-xs"
          onClick={handleCancel}
          disabled={!hasChanges}
        >
          Cancel
        </button>

        <button
          className="bg-orange-500 text-white px-3 py-1 text-xs"
          onClick={handleSave}
          disabled={!hasChanges || saving}
        >
          {saving ? "Saving..." : "Save"}
        </button>
      </div>

    </div>
  );
};

export default AccessibilityConfig;